var __rspack_ns_object = JSON.parse('{"TITLE":"Documents","TABS":{"FILES":"Files"}}')